import { render, staticRenderFns } from "./BankSetting.vue?vue&type=template&id=59aa78d7&"
import script from "./BankSetting.vue?vue&type=script&lang=js&"
export * from "./BankSetting.vue?vue&type=script&lang=js&"
import style0 from "./BankSetting.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports